import React from 'react';
import logoFull from '../../assets/logo-full.webp';
// No Tailwind CSS imports - using plain CSS

const BookmarkAlert = ({ projectCode, method, onClose }) => {

  return (
    <div style={styles.overlay}>
      <div style={styles.modal} className="bookmark-modal">
        {/* Header with logo and title */}
        <div style={styles.header}>
          <div style={styles.logoContainer}>
            <img src={logoFull} alt="ConRa" style={styles.logoIcon} />
          </div>
          <button style={styles.closeButton} onClick={onClose} aria-label="Close">✕</button>
        </div>

        {/* Success Message */}
        <div style={styles.messageContainer}>
          <p style={styles.messageText}>
            <strong>{projectCode ?? 'Project'}</strong> has been saved. You will now receive weekly progress updates via {method === 'email' ? 'Email' : 'WhatsApp'}.
          </p>
        </div>

        {/* Button */}
        <button style={styles.button} onClick={onClose}>
          Got It
        </button>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  modal: {
    backgroundColor: '#fff',
    borderRadius: '16px',
    width: '90%',
    maxWidth: '480px',
    padding: '24px',
    boxShadow: '0 20px 35px -8px rgba(0, 0, 0, 0.2)',
    position: 'relative',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px',
    flexWrap: 'wrap',
    gap: '12px',
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  logoIcon: {
    height: '32px',
    width: 'auto',
    display: 'block',
  },
  logoText: {
    fontSize: '20px',
    fontWeight: '600',
    color: '#1a2b3c',
  },
  badge: {
    backgroundColor: '#e8f4f8',
    color: '#1a5f7a',
    padding: '6px 12px',
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: '500',
  },
  closeButton: {
    background: 'none',
    border: 'none',
    fontSize: '18px',
    color: '#6c757d',
    cursor: 'pointer',
    lineHeight: 1,
    padding: '4px',
  },
  messageContainer: {
    borderRadius: '12px',
    // padding: '20px',
    marginBottom: '28px',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '14px',
  },
  successIcon: {
    width: '28px',
    height: '28px',
    backgroundColor: '#2e7d64',
    color: '#fff',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '16px',
    fontWeight: 'bold',
    flexShrink: 0,
  },
  messageText: {
    margin: 0,
    fontSize: '15px',
    lineHeight: '1.5',
    color: '#1e3a3a',
  },
  button: {
    width: '100%',
    backgroundColor: 'rgba(0, 87, 217, 1)',
    color: '#fff',
    border: 'none',
    borderRadius: '10px',
    padding: '14px',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    marginBottom: '24px',
    ':hover': {
      backgroundColor: '#0e4a62',
    },
  },
  footer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '16px',
    marginBottom: '12px',
    fontSize: '14px',
    color: '#6c757d',
  },
  footerLink: {
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
    ':hover': {
      color: '#1a5f7a',
    },
  },
  footerSeparator: {
    fontSize: '12px',
    marginLeft: '4px',
  },
  footerText: {
    fontSize: '13px',
  },
};

// Add hover effect (since inline styles don't support pseudo-classes natively)
// We'll add a style tag for hover effects
const styleSheet = document.createElement('style');
styleSheet.textContent = `
  .bookmark-button:hover {
    background-color: #0e4a62 !important;
  }
  .footer-link:hover {
    color: #1a5f7a !important;
    cursor: pointer;
  }
  @media (max-width: 480px) {
    .bookmark-modal {
      margin-left: 24px !important;
      margin-right: 24px !important;
      width: auto !important;
    }
  }
  }
`;
document.head.appendChild(styleSheet);

// Apply hover class to button
const buttonWithHover = () => {
  const button = document.querySelector('.bookmark-button');
  if (button) {
    button.classList.add('bookmark-button');
  }
};

export default BookmarkAlert;